export default "__VITE_ASSET__j4VwGbRX__"